import { render } from "./ToolbarInput.vue?vue&type=template&id=08ff6e1a"
import script from "./ToolbarInput.vue?vue&type=script&lang=js"
export * from "./ToolbarInput.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__